import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Observable, Subject, of } from 'rxjs';
import { startWith, map, takeUntil, debounceTime, distinctUntilChanged, switchMap, catchError, tap } from 'rxjs/operators';
import { ProjectsApiService } from 'shared/services/api/projects.api.service';
import { APIResponse } from 'shared/models/api-response';
import { Project } from 'shared/models/project.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-project-selector-dialog',
  standalone: true,
  imports: [
    CommonModule, 
    MatIconModule, 
    MatDialogModule, 
    MatFormFieldModule, 
    MatInputModule, 
    ReactiveFormsModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './project-selector-dialog.component.html',
  styleUrl: './project-selector-dialog.component.scss'
})
export class ProjectSelectorDialogComponent implements OnInit, OnDestroy {
  
  private destroy$ = new Subject<void>();
  
  searchCtrl = new FormControl('');
  filteredProjects$: Observable<Project[]>;
  isLoading = false;

  createNewPath = ''
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _projectsApiService: ProjectsApiService,
    public dialogRef: MatDialogRef<ProjectSelectorDialogComponent>,
    private router: Router,

  ) {
    if(data.createNewPath) {
      this.createNewPath = data.createNewPath
    }
  }

  ngOnInit(): void {
    this.filteredProjects$ = this.searchCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.isLoading = true),
      switchMap(value => 
        this._projectsApiService.get({ searchQuery: value || '' }).pipe(
          catchError(() => {
            this.isLoading = false;
            return of({ success: false, data: { results: [] } } as APIResponse);
          })
        )
      ),
      map((response: APIResponse) => {
        this.isLoading = false;
        return response.success ? (response.data.results as Project[]) : [];
      }),
      takeUntil(this.destroy$)
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectProject(projectId: string): void {
    // Navigate to the new markout page with the selected project's ID
    this.router.navigate([this.createNewPath], { queryParams: { projectId: projectId } });
    this.dialogRef.close();
  }

  createNewProject(): void {
    // Navigate to the new project page
    this.router.navigate(['/account/projects/new']);
    this.dialogRef.close();
  }
}